import { render, staticRenderFns } from "./PushApplicationsTable.vue?vue&type=template&id=3823cd79&"
import script from "./PushApplicationsTable.vue?vue&type=script&lang=ts&"
export * from "./PushApplicationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports